import Vue from "vue";
import Router from "vue-router";
import Meta from "vue-meta";

// import HeaderCommon from "./components/HeaderCommon.vue";
// import FooterCommon from "./components/FooterCommon.vue";


const Home = () => import(/* webpackChunkName: "Home" */ "./views/Home.vue");

const Decision = () => import(/* webpackChunkName: "Decision" */ "./views/Decision.vue");
const Relationship = () => import(/* webpackChunkName: "Relationship" */ "./views/Relationship.vue");
const Stereotype = () => import(/* webpackChunkName: "Stereotype" */ "./views/Stereotype.vue");
const Highperformer = () => import(/* webpackChunkName: "Highperformer" */ "./views/Highperformer.vue");

const Insurance = () => import(/* webpackChunkName: "Insurance" */ "./views/Insurance.vue");
const It = () => import(/* webpackChunkName: "It" */ "./views/It.vue");
const Cardealer = () => import(/* webpackChunkName: "Cardealer" */ "./views/Cardealer.vue");
const Estate = () => import(/* webpackChunkName: "Estate" */ "./views/Estate.vue");
const Shosha = () => import(/* webpackChunkName: "Shosha" */ "./views/Shosha.vue");
const Foodcompany = () => import(/* webpackChunkName: "Foodcompany" */ "./views/Foodcompany.vue");
const Bank = () => import(/* webpackChunkName: "Bank" */ "./views/Bank.vue");
const Securities = () => import(/* webpackChunkName: "Securities" */ "./views/Securities.vue");
const Staffagency = () => import(/* webpackChunkName: "Staffagency" */ "./views/Staffagency.vue");
const Mr = () => import(/* webpackChunkName: "Mr" */ "./views/Mr.vue");

const MainHeader = () => import(/* webpackChunkName: "MainHeader" */ "./components/MainHeader.vue");
const MainHeaderHome = () => import(/* webpackChunkName: "MainHeaderHome" */ "./components/MainHeaderHome.vue");



//https://www.npmjs.com/package/vue-meta
//vue-metaの導入実験を行う予定

Vue.use(Router);
Vue.use(Meta);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      components: {
        mainheader: MainHeaderHome,
        main: Home
      }
    },
    {
      path: "/insurance",
      components: {
        mainheader: MainHeader,
        main: Insurance
      }
    },
    {
      path: "/it",
      components: {
        mainheader: MainHeader,
        main: It
      }
    },
    {
      path: "/cardealer",
      components: {
        mainheader: MainHeader,
        main: Cardealer
      }
    },
    {
      path: "/estate",
      components: {
        mainheader: MainHeader,
        main: Estate
      }
    },
    {
      path: "/shosha",
      components: {
        mainheader: MainHeader,
        main: Shosha
      }
    },
    {
      path: "/foodcompany",
      components: {
        mainheader: MainHeader,
        main: Foodcompany
      }
    },
    {
      path: "/bank",
      components: {
        mainheader: MainHeader,
        main: Bank
      }
    },
    {
      path: "/securities",
      components: {
        mainheader: MainHeader,
        main: Securities
      }
    },
    {
      path: "/staffagency",
      components: {
        mainheader: MainHeader,
        main: Staffagency
      }
    },
    {
      path: "/mr",
      components: {
        mainheader: MainHeader,
        main: Mr
      }
    },
    {
      path: "/decision",
      components: {
        mainheader: MainHeader,
        main: Decision
      }
    },
    {
      path: "/relationship",
      components: {
        mainheader: MainHeader,
        main: Relationship
      }
    },
    {
      path: "/stereotype",
      components: {
        mainheader: MainHeader,
        main: Stereotype
      }
    },
    {
      path: "/highperformer",
      components: {
        mainheader: MainHeader,
        main: Highperformer
      }
    },
  ]
});